import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { lazy, Suspense, useEffect } from "react";
import { Redirect, Route, Switch } from "react-router";
import ErrorBoundary from "./components/ErrorBoundary";
import { useAppDispatch } from "./utils/hooks";
import { loadSettings } from "./redux/slices/settingsSlice";
import { keys } from "./apis";
import Footer from "./components/Footer";
import Header from "./components/Header";
// pages
const Home = lazy(() => import("./pages/Home"));
const Jobs = lazy(() => import("./pages/Jobs"));
const UnderConstruction = lazy(() => import("./pages/UnderDev"));

function Main() {
  const dispatch = useAppDispatch();

  // mount logic
  useEffect(() => {
    dispatch(loadSettings(keys.public));
  }, []); // eslint-disable-line

  return (
    <>
      <Header />
      <Suspense
        fallback={
          <div className="text-center page-placeholder">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: "28px" }} />}
            />
          </div>
        }
      >
        <Switch>
          <Route path="/" exact={true}>
            <ErrorBoundary>
              <Home />
            </ErrorBoundary>
          </Route>
          <Route path="/jobs">
            <ErrorBoundary>
              <Jobs />
            </ErrorBoundary>
          </Route>
          <Route path="/204">
            <ErrorBoundary>
              <UnderConstruction />
            </ErrorBoundary>
          </Route>
          <Route path="/404">
            <div className="page">
              <div className="container">
                <h1>No content</h1>
              </div>
            </div>
          </Route>
          {/* redirects  */}
          <Redirect from="/transport" to="/204" />
          <Redirect to="/404" />
        </Switch>
      </Suspense>
      <Footer />
    </>
  );
}

export default Main;
